import { createQueue, createRound, isCorrectChoice } from "./game-core.js";
import { WORDS } from "./words.js";

const directions = [
  { key: "ArrowLeft", symbol: "←", name: "rodykle į kairę" },
  { key: "ArrowDown", symbol: "↓", name: "rodykle žemyn" },
  { key: "ArrowRight", symbol: "→", name: "rodykle į dešinę" },
];

const game = document.querySelector("#game");
const wordLabel = document.querySelector("#word-label");
const answers = document.querySelector("#answers");
const status = document.querySelector("#status");

let queue = [];
let currentRound = null;
let previousWord = null;
let inputLocked = false;
let feedbackTimer = null;
let wrongTimer = null;

function nextEntry() {
  if (queue.length === 0) {
    queue = createQueue(WORDS, previousWord);
  }
  return queue.shift();
}

function renderRound() {
  const entry = nextEntry();
  currentRound = createRound(entry);
  previousWord = entry.word;
  inputLocked = false;
  status.textContent = "";
  wordLabel.textContent = currentRound.word;
  answers.replaceChildren();

  currentRound.choices.forEach((emoji, index) => {
    const direction = directions[index];
    const button = document.createElement("button");
    button.className = "answer";
    button.type = "button";
    button.dataset.index = String(index);
    button.setAttribute(
      "aria-label",
      `${emoji}, pasirinkti ${direction.name}`
    );

    const picture = document.createElement("span");
    picture.className = "emoji";
    picture.setAttribute("aria-hidden", "true");
    picture.textContent = emoji;

    const key = document.createElement("span");
    key.className = "key";
    key.setAttribute("aria-hidden", "true");
    key.textContent = direction.symbol;

    button.append(picture, key);
    answers.appendChild(button);
  });
}

function restartAnimation(className) {
  game.classList.remove(className);
  void game.offsetWidth;
  game.classList.add(className);
}

function choose(index) {
  if (inputLocked || !currentRound || index < 0 || index > 2) return;

  const selected = answers.children[index];
  if (!isCorrectChoice(currentRound, index)) {
    status.textContent = "Bandyk dar kartą";
    window.clearTimeout(wrongTimer);
    restartAnimation("is-wrong");
    wrongTimer = window.setTimeout(() => game.classList.remove("is-wrong"), 420);
    return;
  }

  inputLocked = true;
  selected.classList.add("is-correct");
  game.classList.add("is-success");
  status.textContent = "Teisingai!";
  feedbackTimer = window.setTimeout(() => {
    game.classList.remove("is-success");
    renderRound();
  }, 900);
}

answers.addEventListener("click", (event) => {
  const button = event.target.closest(".answer");
  if (!button) return;
  choose(Number(button.dataset.index));
});

window.addEventListener("keydown", (event) => {
  const index = directions.findIndex(({ key }) => key === event.key);
  if (index === -1) return;
  event.preventDefault();
  if (event.repeat) return;
  choose(index);
});

window.addEventListener("pagehide", () => {
  window.clearTimeout(feedbackTimer);
  window.clearTimeout(wrongTimer);
});

renderRound();
